export async function process429Response(
  response: Response,
  getToken: () => Promise<string>,
  reset: () => void
): Promise<string | null> {
  if (response.status === 429) {
    reset();
    const token = await getToken();
    return token;
  }
  return null;
}
